export const accessData = [
  { ID: 0, Desc: 'No Access' },
  { ID: 1, Desc: 'User Access' },
  { ID: 99, Desc: 'Administrator Access' },
];
